import React, { memo, useMemo } from 'react'
import PropTypes from 'prop-types'

import { useDispatch, useSelector } from 'react-redux'
import { getJobSettingsState } from '../../../../../store/selectors'
import { rightHipActions } from '../../../../../store/slices'

import {
  CARRIED_MEMBER,
  CONFIGURATION,
  HIP_SLOPE_SKEW_DEGREES_MARKS,
  SLOPE_DEGREES_MARKS,
} from '../../../../../common/constants'

import { FormGroup, FormLabel, RangeSlider } from '../../../../../../../components'

const MemberAngle = (props) => {
  const { label, skewAngle, slopeAngle, onChange, onValidateField, isDuplicate, errors } = props
  const dispatch = useDispatch()
  const configuration = useSelector((state) => getJobSettingsState(state).configuration)

  const isRHipSkewDisabled = useMemo(
    () =>
      [CONFIGURATION.LEFT_RIGHT, CONFIGURATION.LEFT_CENTER_RIGHT].includes(configuration) &&
      label === CARRIED_MEMBER.RIGHT_HIP,
    [label, configuration],
  )

  const handleChangeSlope = (e) => {
    onValidateField(e)
    onChange({
      [e.target.name]: e.target.value,
    })
  }

  const handleChangeSkew = (e) => {
    onValidateField(e)
    onChange({ [e.target.name]: e.target.value })

    if (
      [CONFIGURATION.LEFT_RIGHT, CONFIGURATION.LEFT_CENTER_RIGHT].includes(configuration) &&
      label === CARRIED_MEMBER.LEFT_HIP
    ) {
      dispatch(rightHipActions.modifyCalculation({ name: 'skewAngle', value: e.target.value }))
    }
  }

  return (
    <React.Fragment>
      {label !== CARRIED_MEMBER.JACK ? (
        <FormGroup>
          <FormLabel htmlFor={`${label}.skewAngle`}>Skew (Degrees)</FormLabel>
          <RangeSlider
            name={`${label}.skewAngle`}
            onChange={handleChangeSkew}
            value={skewAngle}
            min={0}
            max={85}
            marks={HIP_SLOPE_SKEW_DEGREES_MARKS}
            disabled={isRHipSkewDisabled || isDuplicate}
            error={errors[`${label}.skewAngle`]}
            data-ga4={`${label}_angle_skewValue:${skewAngle}`}
            data-testid={`${label}.skewAngle`}
          />
        </FormGroup>
      ) : null}

      <FormGroup>
        <FormLabel htmlFor={`${label}.slopeAngle`}>Slope (Degrees)</FormLabel>
        <RangeSlider
          name={`${label}.slopeAngle`}
          onChange={handleChangeSlope}
          value={slopeAngle}
          min={-49}
          max={49}
          addonBefore="Up"
          addonAfter="Down"
          marks={SLOPE_DEGREES_MARKS}
          disabled={isDuplicate}
          error={errors[`${label}.slopeAngle`]}
          data-ga4={`${label}_angle_slopeValue:${slopeAngle}`}
          data-testid={`${label}.slopeAngle`}
        />
      </FormGroup>
    </React.Fragment>
  )
}

MemberAngle.propTypes = {
  label: PropTypes.string,
  isDuplicate: PropTypes.bool,
  slopeAngle: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  skewAngle: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  onValidateField: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
}

MemberAngle.defaultProps = {
  label: CARRIED_MEMBER.JACK,
  isDuplicate: false,
}

export default memo(MemberAngle)
